import { __decorate } from "tslib";
import React, { cloneElement, isValidElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import Trigger from 'choerodon-ui/lib/trigger/Trigger';
import { Action } from 'choerodon-ui/lib/trigger/enum';
import { Placements } from './enum';
import builtinPlacements from './placements';
import autobind from '../_util/autobind';
const popupStyle = { whiteSpace: 'nowrap' };
export default class Dropdown extends PureComponent {
    constructor(props) {
        super(props);
        if ('hidden' in props) {
            this.state = {
                hidden: props.hidden,
            };
        }
        else if ('visible' in props) {
            this.state = {
                hidden: !props.visible,
            };
        }
        else if ('defaultHidden' in props) {
            this.state = {
                hidden: props.defaultHidden,
            };
        }
        else {
            this.state = {
                hidden: !props.defaultVisible,
            };
        }
    }
    get triggerAction() {
        const { trigger } = this.props;
        return trigger;
    }
    get transitionName() {
        const { placement } = this.props;
        let result = 'slide-up';
        if (placement && placement.startsWith('top')) {
            result = 'slide-down';
        }
        return result;
    }
    get prefixCls() {
        const { suffixCls, prefixCls } = this.props;
        return getProPrefixCls(suffixCls, prefixCls);
    }
    /**
     * 调用传入的onHiddenChange方法
     *
     * @param {boolean} hidden
     */
    handlePopupHiddenChange(hidden) {
        const { onHiddenChange, onVisibleChange, hidden: propsHidden, visible: propsVisible, } = this.props;
        if (propsHidden === undefined && propsVisible === undefined) {
            this.setState({
                hidden,
            });
        }
        if (onHiddenChange) {
            onHiddenChange(hidden);
        }
        if (onVisibleChange) {
            onVisibleChange(!hidden);
        }
    }
    handleClick(e) {
        const { onOverlayClick, hidden, visible } = this.props;
        const { onClick } = this.renderedContentProps || {};
        if (onOverlayClick) {
            onOverlayClick(e);
        }
        if (onClick) {
            onClick(e);
        }
        if (hidden === undefined && visible === undefined) {
            this.setState({
                hidden: true,
            });
        }
    }
    getContent(...props) {
        const { overlay } = this.props;
        if (typeof overlay === 'function') {
            return overlay(...props);
        }
        return overlay;
    }
    renderPopupContent(...props) {
        const content = this.getContent(...props);
        if (isValidElement(content)) {
            this.renderedContentProps = content.props;
            return cloneElement(content, {
                onClick: this.handleClick,
            });
        }
    }
    componentWillReceiveProps({ hidden, visible }) {
        if (hidden !== undefined) {
            this.setState({
                hidden,
            });
        }
        else if (visible !== undefined) {
            this.setState({
                hidden: !visible,
            });
        }
    }
    render() {
        const { prefixCls, state: { hidden }, props: { children, placement, popupClassName, getPopupContainer, onHiddenBeforeChange }, } = this;
        return (React.createElement(Trigger, { prefixCls: prefixCls, action: this.triggerAction, builtinPlacements: builtinPlacements, popupPlacement: placement, popupContent: this.renderPopupContent, popupStyle: popupStyle, popupClassName: popupClassName, onPopupHiddenChange: this.handlePopupHiddenChange, onPopupHiddenBeforeChange: onHiddenBeforeChange, popupHidden: hidden, getPopupContainer: getPopupContainer }, children));
    }
}
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
    trigger: PropTypes.arrayOf(PropTypes.oneOf([Action.focus, Action.hover, Action.click, Action.contextMenu])),
    overlay: PropTypes.any,
    placement: PropTypes.oneOf([
        Placements.bottomLeft,
        Placements.bottomCenter,
        Placements.bottomRight,
        Placements.topLeft,
        Placements.topCenter,
        Placements.topRight,
    ]),
    hidden: PropTypes.bool,
    visible: PropTypes.bool,
    onHiddenChange: PropTypes.func,
    onHiddenBeforeChange: PropTypes.func,
    onVisibleChange: PropTypes.func,
    onOverlayClick: PropTypes.func,
    suffixCls: PropTypes.string,
    prefixCls: PropTypes.string,
    defaultHidden: PropTypes.bool,
    defaultVisible: PropTypes.bool,
    popupClassName: PropTypes.string,
};
Dropdown.defaultProps = {
    suffixCls: 'dropdown',
    placement: Placements.bottomLeft,
    trigger: [Action.hover, Action.focus],
    defaultHidden: true,
};
__decorate([
    autobind
], Dropdown.prototype, "handlePopupHiddenChange", null);
__decorate([
    autobind
], Dropdown.prototype, "handleClick", null);
__decorate([
    autobind
], Dropdown.prototype, "renderPopupContent", null);
